import moment from "moment";

export const shiftReportSummaryTableColumns = (datesColumns, data) => {
    return datesColumns.map(column => ({
        Header: column === 'group_name' ? '' : moment(column).format('MM-DD-YY'),
        accessor: column,
        Cell: (cell) => {
            const row = cell.row.original;
            return getSummaryCell(column, row, cell);
        },
    }));
}


export const shiftReportTableColumns = (datesColumns, data, handleCellClick) => {
    return datesColumns.map(column => ({
        Header: column === 'rig' ? '' : moment(column).format('MM-DD-YY'),
        accessor: column,
        Cell: (cell) => {
            const row = cell.row.original;
            if (row.isSummary) {
                return getSummaryCell(column, row, cell, 'rig');
            }

            const cellData = data.filter(rig => rig.name === row.rig_id && rig.shift === row.shift)[0].data.filter(item => item.date === cell.column.id)[0];
            if (isNaN(cell.value) || cell.value === 0) {
                return <div className={`${row.isLastRig ? 'last-rig' : ''}`}>{cell.value}</div>;
            }
            
            const shouldHighlight = cell.value > row.optimal_count && new Date(cellData.date).getTime() <= new Date().getTime();

            return <div 
                    onClick={() => handleCellClick(cellData.daily_id, cell.value)} 
                    className={[
                        `${shouldHighlight ? 'highlighted-red' : ''} ${cell.value > 0 ? 'clickable': ''}`,
                        `${row.isLastRig ? ' last-rig' : ''}`
                    ]}>
                        {cell.value}
            </div>
        },
    }));
}

const getSummaryCell = (column, row, cell, columnAccessor = 'group_name') => {
    const isFutureDate = new Date(column).getTime() > new Date().getTime()
    if (column === columnAccessor) {
        return <div className='first-cell'>{cell.value}</div>;
    }

    if (row[columnAccessor] === 'Total Labor Count' || isNaN(cell.value) || isFutureDate) {
        return <div>{cell.value}</div>;
    }

    const cellValue = row.group_name === 'Labor Cost Impact $' || row.rig === 'Labor Cost Impact $' ? 
        cell.value.toLocaleString('en-US') : 
        cell.value;

    if (cell.value > 0) {
        return <div className='highlighted-red'>{cellValue}</div>;
    }

    if (cell.value < 0) {
        return <div className='highlighted-green'>{cellValue}</div>;
    }

    return <div>{cellValue}</div>;
}